import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=0dc4ca56&scoped=true&"
import script from "./estatisticas.vue?vue&type=script&lang=js&"
export * from "./estatisticas.vue?vue&type=script&lang=js&"
import style0 from "./estatisticas.vue?vue&type=style&index=0&id=0dc4ca56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4ca56",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc4ca56')) {
      api.createRecord('0dc4ca56', component.options)
    } else {
      api.reload('0dc4ca56', component.options)
    }
    module.hot.accept("./estatisticas.vue?vue&type=template&id=0dc4ca56&scoped=true&", function () {
      api.rerender('0dc4ca56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/estatisticas/estatisticas.vue"
export default component.exports